import collectorsAutoSupplyDefaults from '../collectors-auto-supply/config.js';

export default {
  includes: ['collectors-auto-supply'],
  ...collectorsAutoSupplyDefaults,
};
